
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSlightlycloudyPolartwilight as ObiSlightlycloudyPolartwilightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-slightlycloudy-polartwilight.js';
 
 
 

 
 export const ObiSlightlycloudyPolartwilight = createComponent({
   react: React,
   tagName: 'obi-slightlycloudy-polartwilight',
   elementClass: ObiSlightlycloudyPolartwilightElement,
   events: {
     
   }
  });
 
 